import { createStudentPart } from "./createStudentPart"
import { createInstitutionPart } from "./createInstitutionPart"
import type { TutorialPart } from "./types"

export type { TutorialPart } from "./types"

/** Order matters — parts run in this sequence for whoever's policies satisfy them. */
export const TUTORIAL_PARTS: TutorialPart[] = [createStudentPart, createInstitutionPart]
